import TenantPage from 'layouts/TenantPage';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { expertiseService } from 'features/cost-analysis/team/expertises/api/expertise.service';
import toast from 'shared/utils/toast';
import { IExpertise } from '../types';
import ExpertiseForm from '../components/ExpertiseForm';

export const AddExpertise = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const translationPrefix = 'pages.expertises.new';

  const [expertise, setExpertise] = useState<Partial<IExpertise>>({
    fte: 1,
    monthly_hours: 164
  });

  const saveExpertise = (value) => {
    expertiseService.add(value).then((res) => {
      if (res) {
        toast.success(t('pages.expertises.new.success'));
        navigate(`../${res.id}`);
      }
    });
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <ExpertiseForm expertise={expertise as IExpertise} onSubmit={saveExpertise} />
    </TenantPage>
  );
};

export default AddExpertise;
